const heroHomeSetup = () => {
  const components = document.querySelectorAll('[data-component-hero-home]');

  components.forEach((component) => {

  });
};


var swiper = new Swiper(".homeGallery", {

  speed: 1200,
  slidesPerGroup: 1,
  slidesPerView: 1,
  spaceBetween: 30,
  grabCursor: true,
  loop: true,
  autoplay: {
    delay: 6000,
  },

});
heroHomeSetup();